import {request} from '@/helpers/apiClient';
import {CATEGORY_CONFIG} from '@/utils/constants/apiConfig/categoryConfig';

export const getCategoryList = async () => {
  // This will construct the final endpoint for:
  // https://b2b-lylty-admin-qa.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com/api/v1/category?scope=pepsi
  return request(CATEGORY_CONFIG.CATEGORY_LIST);
};
